<template>
  <div class="row">
    <div class="col-md-4">
      <div class="card shadow">
        <div class="card-body">
          <h4 class="f-bold cl-primary text-left pl-3 pt-4 text-center">
            Not Match Form
          </h4>
          <form @submit.prevent="submitSingleInvoiceChecking">
            <div class="row">
              <div class="col-12 col-md-12">
                <div class="form-group">
                  <label for="description">Description</label>
                  <textarea
                    placeholder="Description"
                    class="form-control"
                    id="description"
                    rows="3"
                    v-model="form.description"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="carton">Carton</label>
                  <input
                    type="text"
                    class="form-control"
                    id="carton"
                    aria-describedby="carton"
                    placeholder="Carton"
                    v-model="form.carton"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="cbm">CBM</label>
                  <input
                    type="text"
                    class="form-control"
                    id="cbm"
                    aria-describedby="cbm"
                    placeholder="CBM"
                    v-model="form.cbm"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="d-flex justify-content-center">
                  <button class="btn btn-primary px-5" type="submit">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="col-md-8">
      <div class="card shadow">
        <div class="card-body">
          <h4 class="f-bold cl-primary text-left pl-3 pt-4 text-center">
            Not Match List
          </h4>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <td>Description</td>
                  <td>Carton</td>
                  <td>CBM</td>
                  <td>Option</td>
                </tr>
              </thead>
              <tr v-for="(invoices, i) in invoices" :key="i">
                <td>{{ invoices.description }}</td>
                <td>{{ invoices.carton }}</td>
                <td>{{ invoices.cbm }}</td>
                <td>
                  <div class="d-flex justify-content-around">
                    <p
                      style="cursor: pointer"
                      class="btn btn-link mb-0"
                      @click.prevent="deleteInvoice(invoices.id)"
                    >
                      <span class="material-icons"> delete </span>
                    </p>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <div class="d-flex justify-content-end">
            <button class="btn btn-primary px-5" v-on:click="sendNotify()">
              Send to admin
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  props: ["package_id", "sendNotifyInvoices"],
  data() {
    return {
      loading: true,
      isEdit: false,
      invoices: "",
      showInv: false,
      listDetailPackage: {},
      package_detail: {},
      package_invoice: {},
      customer_detail: {},
      payment_proof: {},
      delivery_proof: {},
      not_match_invoice: [],
      isDeliveryProof: false,
      form: {
        package_id: "",
        description: "",
        carton: "",
        cbm: "",
        price_per_cbm: "",
        total: "",
        warehouse_address: "warehouse address test",
      },
    };
  },
  mounted() {
    this.getInvoices(this.package_id);
  },
  methods: {
    sendNotify() {
      this.sendNotifyInvoices();
    },

    submitSingleInvoiceChecking() {
      this.form.package_id = this.package_id;
      this.form.total = 0;
      this.form.price_per_cbm = 0;
      Vue.swal({
        title: "Are you sure?",
        icon: "question",
        showCancelButton: true,
        cancelButtonColor: "#eb4d4b",
        confirmButtonText: "Yes, Submit!",
      }).then((result) => {
        if (result.isConfirmed) {
          const endpoint = "checking-invoice/single";
          this.$api.post(endpoint, this.form, (status, data, message) => {
            if (status === 200) {
              this.loading = false;
              console.log(data);
              Vue.swal("Success", "Invoice successfully added", "success").then(
                () => {
                  this.getInvoices(this.package_id);
                  this.resetForm();
                  //   this.scrollToEnd();
                }
              );
            } else {
              this.loading = false;
              console.log(message);
            }
          });
        }
      });
    },

    deleteInvoice(id) {
      this.loading = true;
      const endpoint = "checking-invoice/" + id;
      this.$api.delete(endpoint, (status, message) => {
        if (status === 200) {
          this.loading = false;
          Vue.swal("Success", "Invoice deleted!", "success").then(() => {
            this.getInvoices(this.package_id);
          });
        } else {
          this.loading = false;
          console.log(message);
        }
      });
    },

    getInvoices(id) {
      this.loading = true;
      const endpoint = "checking-invoice/" + id;
      this.$api.get(endpoint, (status, data, message) => {
        console.log(status);
        if (status == 200) {
          this.loading = false;
          this.invoices = data.package_invoice;
        } else {
          this.loading = false;
          console.log(message);
        }
      });
    },

    resetForm() {
      this.form.description = "";
      this.form.carton = "";
      this.form.cbm = "";
      this.form.price_per_cbm = "";
      this.form.total = "";
    },
  },
};
</script>
